module.exports = __webpack_public_path__ + "img/imagedown.d9a16bd8.png";